import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import {Elements, PaymentRequestButtonElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_R00q6oRX8Zg5Qz3bDUqUivcK00vfUkcN9F');

export default function InjectGooglePay(props) {
  return (
    <Elements stripe={stripePromise}>
      <GooglePay />
    </Elements>
  );
}

const GooglePay = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentRequest, setPaymentRequest] = useState(null);
  

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }

    const pr = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Demo total',
        amount: 1999,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    // Check the availability of the Payment Request API.
    pr.canMakePayment().then(result => {
      if (result) {
        setPaymentRequest(pr);
      }
    });    

    pr.on('paymentmethod', async (ev) => {

      const {error: backendError, clientSecret} = await fetch(
        'https://fe38-202-8-114-204.ngrok.io/create-payment-intent',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            paymentMethodType: 'card',
            currency: 'usd',
          }),
        }
      ).then((r) => r.json());

      if (backendError) {
        ev.complete('fail');
        console.log(backendError.message);
        return;
      }

      console.log('Client secret returned');

      // Confirm the PaymentIntent without handling potential next actions yet.
      const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
        clientSecret,
        { payment_method: ev.paymentMethod.id },
        { handleActions: false }
      );

      if (confirmError) {
        // Report to the browser that the payment failed, prompting it to
        // re-show the payment interface, or show an error message and close
        // the payment interface.
        ev.complete('fail');
      } else {
        // Report to the browser that the confirmation was successful, prompting
        // it to close the browser payment method collection interface.
        ev.complete('success');
        // Check if the PaymentIntent requires any actions and if so let Stripe.js
        // handle the flow. If using an API version older than "2019-02-11"
        // instead check for: `paymentIntent.status === "requires_source_action"`.
        if (paymentIntent.status === "requires_action") {
          // Let Stripe.js handle the rest of the payment flow.
          const { error } = await stripe.confirmCardPayment(clientSecret);
          if (error) {
            // The payment failed -- ask your customer for a new payment method.
            console.log('The payment failed -- ask your customer for a new payment method.');
          } else {
            // The payment has succeeded.
            console.log('The payment has succeeded with 3ds.');
          }
        } else {
          // The payment has succeeded.
          console.log('The payment has succeeded without 3ds.');
        }
      }
    });

  }, [stripe, elements]);
  return (
    <div>
      <h1>Google Pay</h1>

      {paymentRequest && <PaymentRequestButtonElement options={{paymentRequest}} />}

      
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/payment/GooglePay.js